import DownloadIcon from './component.jsx'
export default DownloadIcon
